export const TEST_ID = 'mixApplyPage';

export const MIX_DETAIL_ROUTE_PREFIX = '/chemicals/mixes';
